const Frozen = ['Frozen_00.png','Frozen_01.png','Frozen_02.png','Frozen_03.png','Frozen_04.png','Frozen_05.png'];
export default Frozen